import { useState, useEffect } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { t, numStr } from '../../../components/common/Translate';
import { Record } from '../../../config/Record/RecordEntity';
import { decodeVinCountry, vehInfoRequired } from '../../../config';
import { recordActions, Auth } from '../../../config/configuration/react';

export const useVehicle = (recordId) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const vehicleVersion = useSelector((state) => state.reduxRecords.data[recordId])?.vehicle?.versionList;
  const valuationVersion = useSelector((state) => state.reduxRecords.data[recordId])?.valuation?.versionName;
  const brandLabel = useSelector((state) => state.reduxRecords.data[recordId])?.vehicle?.brandLabel;
  const modelLabel = useSelector((state) => state.reduxRecords.data[recordId])?.vehicle?.modelLabel;
  const registrationDate = useSelector((state) => state.reduxRecords.data[recordId])?.vehicle?.registrationDate?.date;
  const vin = useSelector((state) => state.reduxRecords.data[recordId])?.vehicle?.vin;
  const registration = useSelector((state) => state.reduxRecords.data[recordId])?.vehicle?.registration;
  const mileage = useSelector((state) => state.reduxRecords.data[recordId])?.vehicle?.mileage;
  const vehicle = useSelector((state) => state.reduxRecords.data[recordId])?.vehicle;
  const buyingProject = useSelector((state) => state.reduxRecords.data[recordId])?.appointment?.buyingProject;
  const c2bOffer = useSelector((state) => state.reduxRecords.data[recordId])?.appointment?.c2bOffer;
  const status = useSelector((state) => state.reduxRecords.data[recordId])?.histovecStatus?.status;
  const record = useSelector((state) => state.reduxRecords.data[recordId]) || {};
  const histovecStatus = useSelector((state) => state.reduxRecords.data[recordId])?.histovecStatus;
  const histovecAlerts = useSelector((state) => state.reduxRecords.data[recordId])?.histovecAlerts;

  const recordEntity = new Record(record);
  const active = recordEntity.displayVehicleIsAllowed();
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const countryId = useSelector((state) => state.reduxRecords.data[recordId])?.record?.countryId;
  const [isOpen, setIsOpen] = useState(false);
  const [body, setBody] = useState('');
  const [ownerMode, setOwnerMode] = useState('private' || 'company');
  const roleIsViewer = Auth.roleViewerAccess();
  const [privateOwner, setPrivateOwner] = useState({
    registration,
    privateName: histovecStatus?.privateName || '',
    privateFormula: histovecStatus?.privateFormula || '',
    privateLastName: histovecStatus?.privateLastName || '',
  });
  const [companyOwner, setCompanyOwner] = useState({
    registration,
    companyName: histovecStatus?.companyName || '',
    companyFormula: histovecStatus?.companyFormula || '',
    companySiren: histovecStatus?.companySiren || '',
  });

  const [isOpenEquipments, setIsOpenEquipments] = useState(false);

  const handleKeyPress = (e) => {
    if (e.target.value.length > e.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength);
    }
  };
  const setHistoryChanges = (e) => {
    if (ownerMode === 'company') {
      setCompanyOwner({ ...companyOwner, [e.target.name]: e.target.value, registration });
    }
    if (ownerMode === 'private') {
      setPrivateOwner({ ...privateOwner, [e.target.name]: e.target.value, registration });
    }
  };
  const retriveHistovecInfo = () => {
    if (ownerMode === 'company') {
      dispatch(recordActions.retriveHistovecInfo(recordId, companyOwner));
      setPrivateOwner({});
    } else if (ownerMode === 'private') {
      dispatch(recordActions.retriveHistovecInfo(recordId, privateOwner));
      setCompanyOwner({});
    }
    setIsOpen(!isOpen);
    setBody('');
  };

  const showModifyVersionAlert = recordEntity.type() === 2 && recordEntity.status() <= 2;

  useEffect(() => {
    if (vehicle && active) {
      vehInfoRequired[(countryId !== 'DE' && 'default') || 'DE'].map((i) => {
        if (_.get(vehicle, i, null) === null) {
          setAlertMessage(t('message'));
          return setAlert(true);
        }
        if (showModifyVersionAlert) {
          setAlertMessage(t('alertModifyVersionPossible'));
          return setAlert(true);
        }
        return null;
      });
    }
  });
  const goToVehIdentify = () => {
    if (!active) return;
    history.push({
      pathname: `/files/${recordId}/identification`,
      state: {
        ...history.location.state,
      },
    });
  };

  const toggleHistovecInfo = (e) => {
    e.stopPropagation();
    console.log(!status || status !== 'pending');
    setIsOpen(true);
    setBody('');
  };

  const handleCancel = () => {
    setIsOpen(!isOpen);
    setBody('');
  };

  const vehicleTitle = [];
  if (brandLabel) vehicleTitle.push(brandLabel);
  if (modelLabel) vehicleTitle.push(modelLabel);
  if (registrationDate) vehicleTitle.push(registrationDate.substring(0, 4));

  const labels = [];
  if (decodeVinCountry.includes(recordEntity.getCountry()) && vin) {
    labels.push({
      label: t('vin'),
      value: vin,
    });
  } else if (registration) {
    labels.push({
      label: t('registration'),
      value: registration,
    });
  }
  if (mileage)
    labels.push({
      label: t('mileage'),
      value: numStr(mileage),
    });
  if (buyingProject)
    labels.push({
      label: t('purchase_project'),
      value: buyingProject,
    });
  if (c2bOffer)
    labels.push({
      label: t('offer_received'),
      value: numStr(c2bOffer),
    });

  return {
    vehicleTitle: vehicleTitle.join(' - '),
    versionName: valuationVersion || vehicleVersion,
    labels,
    goToVehIdentify,
    active,
    alert,
    alertMessage,
    countryId,
    toggleHistovecInfo,
    handleCancel,
    isOpen,
    body,
    status,
    histovecStatus,
    histovecAlerts,
    privateOwner,
    setHistoryChanges,
    companyOwner,
    retriveHistovecInfo,
    ownerMode,
    setOwnerMode,
    handleKeyPress,
    roleIsViewer,
    carEquipment: vehicle?.carEquipment,
    setIsOpenEquipments,
    isOpenEquipments,
    isNrmFile: recordEntity.isNrmRecord(),
  };
};
